import {
  ConnectionListResult,
  FeatureFlagsContext,
  GridSortProps,
  MaxCountsResultData,
  PaginatedQueryWrapper
} from '@tableau/data-catalog-shared';
import * as React from 'react';
import { Messages } from '../../../gen-src/Localize';
import { LensUpstreamVirtualConnectionTablesQuery, LensUpstreamVirtualConnectionTablesQueryVariables, LensUpstreamVirtualConnectionTablesQuery_lenses_upstreamVirtualConnectionTablesConnection_nodes } from '../../../gen-src/queries/LensUpstreamVirtualConnectionTablesQuery';
import { VirtualConnectionTablesDisplayGridRowDataFragment } from '../../../gen-src/queries/VirtualConnectionTablesDisplayGridRowDataFragment';
import { VirtualConnectionTableSortOrder } from '../../../gen-src/queries/globalTypes';
import { LensUpstreamVirtualConnectionTablesQueryGql } from '../../queries/LensUpstreamVirtualConnectionTablesQueryGql';
import { VirtualConnectionTablesDisplayGrid } from '../sharedDisplayGrid/VirtualConnectionTablesDisplayGrid';
import { VirtualConnectionTablesValidSortFields } from '../sorting/sortProviders/VirtualConnectionTablesGridSortProvider';
import { getRowDataWithMaxCountsForVirtualConnectionTable } from '../table/functions/VirtualConnectionTableRowDataFunctions';
import { VirtualConnectionTablesDisplayGridRowData } from '../table/types/VirtualConnectionTablesDisplayGridRowData';

type QueryVariables = LensUpstreamVirtualConnectionTablesQueryVariables;
type QueryResults = LensUpstreamVirtualConnectionTablesQuery;
type QueryResultListNode = LensUpstreamVirtualConnectionTablesQuery_lenses_upstreamVirtualConnectionTablesConnection_nodes;
type GridRowData = VirtualConnectionTablesDisplayGridRowData;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData?.lenses[0] && resultData.lenses[0].upstreamVirtualConnectionTablesConnection;
}

export type LensUpstreamVirtualConnectionTablesQueryGridProps =
  GridSortProps<VirtualConnectionTablesValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly rowCount: number | null;
  };

export const LensUpstreamVirtualConnectionTablesQueryGrid: React.FC<LensUpstreamVirtualConnectionTablesQueryGridProps> = props => {
  const { publishedConnectionsLineageEnabled } = React.useContext(FeatureFlagsContext);
  const emptyGridMessage = Messages.EmptyUpstreamVirtualConnectionTablesLineageGridMessage();

  return (
    // Query without Selection
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={LensUpstreamVirtualConnectionTablesQueryGql}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        orderBy: props.orderBy as VirtualConnectionTableSortOrder,
        publishedConnectionsLineageEnabled
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForVirtualConnectionTable}
    >
      {({ rowStore }) =>
        <VirtualConnectionTablesDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      }
    </PaginatedQueryWrapper>
  );
};

function getRowDataForVirtualConnectionTable(
  virtualConnectionTable: VirtualConnectionTablesDisplayGridRowDataFragment,
  resultData: QueryResults,
): VirtualConnectionTablesDisplayGridRowData {
  return getRowDataWithMaxCountsForVirtualConnectionTable(virtualConnectionTable, selectMaxCountsResult(resultData));
}

function selectMaxCountsResult(resultData: QueryResults): MaxCountsResultData {
  return resultData?.lenses && resultData.lenses[0];
}
